import(/* webpackMode: "eager", webpackExports: ["GoogleSignUpButton"] */ "/app/apps/sb-shell/app/(recaptcha)/sign-up/GoogleSignUpButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/sb-shell/app/(recaptcha)/sign-up/SignUpForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/packages/core-events/src/search/SearchEventEmitter.tsx");
